import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=b28f13fa&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports